<script>
    import ServiceRecommendationModel from "./Models/serviceRecommendationModel";
    import Loader from './Components/Loader.svelte';
    import {addFormModal} from './Forms/ModalFormManager.svelte';
    import {notifier} from '@beyonk/svelte-notifications';
    import {confirm} from './Components/Confirmation.svelte';
    import SortableTable from './Components/SortableTable.svelte';
    import {forms} from './lib/forms';
    import {tables} from './lib/tables';

    let recommendationsList = ServiceRecommendationModel.getServiceRecommendationList();

    let importing;


    function addRecommendation() {
        addFormModal({
            fields: forms['serviceRecommendation']
        }).then(formData => {
            ServiceRecommendationModel.createServiceRecommendation(formData).then(() => notifier.success("Recommendation Added"));
        }).catch((err) => console.error(err));
    }

    function editRecommendation(recommendation) {
        addFormModal({
            fields: forms['serviceRecommendation'],
            data: recommendation
        }).then(formData => {
            ServiceRecommendationModel.saveServiceRecommendation(formData).then(() => notifier.success("Recommendation Saved"));
        }).catch(() => null)
    }

    function deleteRecommendation(recommendation) {
        confirm("Are you sure you want to delete this recommendation?").then(() => {
            ServiceRecommendationModel.deleteServiceRecommendation(recommendation).then(() => {
                notifier.success("Recommendation Deleted");
            });
        }).catch(() => null)
    }

    let sortFields = tables['serviceRecommendations'];
</script>

<Loader loading={!$recommendationsList}>
    <div class="container is-fluid">
        <h1 class="title is-1">Recommendations</h1>
        <SortableTable {sortFields} tableData={$recommendationsList} tableClass="ServiceTable">
            <div slot="filterActions"><button class="button is-success" on:click={addRecommendation}>Add Service Recommendation</button></div>
            <div slot="rowActions" let:row={recommendation}>
                <div class="buttons is-centered">
                    <button class="button is-danger" on:click={() => deleteRecommendation(recommendation)}>Delete</button>
                    <button class="button is-link" on:click={() => editRecommendation(recommendation)}>Edit</button>
                </div>
            </div>
        </SortableTable>
    </div>
</Loader>

{#if importing}
    <div class="importLoader">
        <Loader></Loader>
    </div>
{/if}

<style>
    .container {
        padding-left: 32px;
        padding-right: 32px;
    }

    :global(.ServiceTable td[data-field="Gray"]) {
        background-color: #6A8192 !important;
        color: white;
    }

    :global(.ServiceTable td[data-field="Blue"]) {
        background-color: #3E9AC3 !important;
        color: white;
    }

    :global(.ServiceTable td[data-field="Purple"]) {
        background-color: #765F85 !important;
        color: white;
    }

    :global(.ServiceTable td[data-field="Orange"]) {
        background-color: #FC9D33 !important;
        color: white;
    }
</style>